import classNames from 'classnames'
import { LateCancelRow } from '../late-cancel-row'
import type { LateCancelsListProps } from './late-cancels-list.interface'
import classes from './late-cancels-list.module.scss'

const COLUMNS = ['Client', 'Appointment', 'Cancelled', 'Policy', 'Action'] as const

/** Not the core Table: it maps cells by position and has no expandable cell, row action or card layout. */
export function LateCancelsList({ records, pendingId, onResolve, onUndo }: LateCancelsListProps) {
  return (
    <div role="table" aria-label="Late cancels" className={classes.table}>
      <div role="row" className={classNames(classes.row, classes.header)}>
        {COLUMNS.map((column) => (
          <div
            key={column}
            role="columnheader"
            className={classNames(classes.columnHeader, { [classes.visuallyHidden]: column === 'Action' })}
          >
            {column}
          </div>
        ))}
      </div>
      {records.map((record) => (
        <LateCancelRow
          key={record.id}
          record={record}
          isPending={pendingId === record.id}
          onResolve={onResolve}
          onUndo={onUndo}
          className={classes.row}
        />
      ))}
    </div>
  )
}
